import React from 'react'
import Logo from "../components/Logo"


const NavPayments = () => {
    return (
        <div className='nav-desktop-payments'>
            <div className='inner'>
                <Logo></Logo>
            </div>
        </div>
    )
}

export default NavPayments


// WEBPACK FOOTER //
// ./resources/js/layout/NavPayments.js